import { css } from '@emotion/react';
import { red9 } from '@fire/_color';

export const error = css`
  display: inline-block;
  font-size: 16px;
  color: ${red9};
  margin: 4px 0;
`;
